import React, { useImperativeHandle } from 'react'
import { useFormik, FormikProvider, FieldArray } from 'formik'
import moment from 'moment';

// components
import FormSectionHeader from '../../../../../components/forms/FormSectionHeader/FormSectionHeader.component';
import InputField from '../../../../../components/forms/InputField/InputField.component';
import CycleCountInput from '../../../../../components/forms/lists/CycleCountInput/CycleCountInput.component';
import AsyncSelectField from '../../../../../components/forms/AsyncSelectField/AsyncSelectField.component';

// gql
import { GET_ALL_EQUIPMENT_CATEGORIES_FOR_SELECT_FIELD } from '../../../../../graphql/equipmentCategory/equipmentCategory.queries';

const CycleCountForm = React.forwardRef(({ prefillData, errors }, ref) => {

    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))
    const formik = useFormik({
        initialValues: {
            dateCounted: moment(),
            allEquipment: prefillData ? [...prefillData] : [],
            equipment: [],
            category: null
        },
        onSubmit: values=> {
            alert(JSON.stringify(values, null, 2));
        },
    });

    return (<FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
            <InputField 
                id="dateCounted"
                placeholder="Date"
                type="date"
                onChange={value => formik.setFieldValue('dateCounted', value)}
                value={formik.values.dateCounted}
                isValid={errors['dateCounted']}
            />

            <AsyncSelectField 
                id="category"
                value={formik.values.category}
                placeholder="Category"
                onChange={value => {
                    
                    formik.setFieldValue('category', value.value)
                    formik.setFieldValue('equipment', [...formik.values.allEquipment.filter(item => {
                        return item.category ? item.category.id == value.value : false
                    })])
                }}
                query={{
                    query: GET_ALL_EQUIPMENT_CATEGORIES_FOR_SELECT_FIELD,
                    rules: {
                        loopField: 'allEquipmentCategories',
                        label: ['name'],
                        value: 'id'
                    }
                }}
                required={true}
                isValid={errors['category']}
            />

            <FormSectionHeader text='Equipment' />

            <FieldArray 
                name='equipment'
                render={({ remove }) => (
                    <React.Fragment>
                        {
                            formik.values.equipment.map((item, index) => {
                                return (<CycleCountInput 
                                    key={index}
                                    prefix={`equipment.${index}`}
                                    handleChange={formik.handleChange}
                                    handleSelectChange={value => formik.setFieldValue(`equipment.${index}.reason`, value.value)}
                                    equipmentName={item.name}
                                    expectedQty={item.expectedQuantity}
                                    countedQty={item.countedQuantity}
                                    handleRemove={(e) => {
                                        e.preventDefault()
                                        remove(index)
                                    }}
                                    errors={errors['equipment'].length >= index ? errors['equipment'][index] : {}}
                                />)
                            })
                        }
                    </React.Fragment>
                )}
            />
        </form>
    </FormikProvider>)
})

export default CycleCountForm